// src/components/AppVersions/VersionList.jsx
import { useState } from "react";
import { useModalContext } from "../CustomModal/ModalProvider.jsx";
import { appVersionService } from "../../services/appVersionService";
import {
  StyledTable,
  StyledTableHead,
  StyledTableRow,
  StyledTableHeader,
  StyledTableCell,
  StyledButtonVisualizar,
  Badge,
  LoadingContainer,
  LoadingSpinner,
  EmptyMessage,
  TableContainer,
} from "./styles";
import { VersionDetailsModal } from "./VersionDetailsModal";

export function VersionList({ versions, loading, error, reload }) {
  const { showError } = useModalContext();
  const [savingGuid, setSavingGuid] = useState(null);
  const [detailsVersion, setDetailsVersion] = useState(null);

  async function handleToggleMandatory(version) {
    setSavingGuid(version.guid);
    try {
      await appVersionService.updateVersion(version.guid, {
        is_mandatory: !version.is_mandatory,
      });
      await reload();
    } catch (err) {
      showError("Erro!", "Não foi possível alterar a obrigatoriedade.");
    } finally {
      setSavingGuid(null);
    }
  }

  if (loading) {
    return (
      <LoadingContainer>
        <LoadingSpinner />
      </LoadingContainer>
    );
  }

  if (error) {
    return (
      <EmptyMessage $error>
        Não foi possível carregar o histórico de versões. Tente novamente em instantes.
      </EmptyMessage>
    );
  }

  if (!versions || versions.length === 0) {
    return <EmptyMessage>Nenhuma versão cadastrada ainda.</EmptyMessage>;
  }

  return (
    <>
      <TableContainer>
        <StyledTable>
          <StyledTableHead>
            <StyledTableRow>
              <StyledTableHeader>Versão</StyledTableHeader>
              <StyledTableHeader>Plataforma</StyledTableHeader>
              <StyledTableHeader>Canal</StyledTableHeader>
              <StyledTableHeader>Tipo</StyledTableHeader>
              <StyledTableHeader>Runtime</StyledTableHeader>
              <StyledTableHeader>Obrigatória</StyledTableHeader>
              <StyledTableHeader>Criada em</StyledTableHeader>
              <StyledTableHeader></StyledTableHeader>
            </StyledTableRow>
          </StyledTableHead>
          <tbody>
            {versions.map((v) => (
              <StyledTableRow key={v.guid}>
                <StyledTableCell>{v.version}</StyledTableCell>
                <StyledTableCell>{v.platform}</StyledTableCell>
                <StyledTableCell>
                  <Badge $channel={v.channel}>{v.channel}</Badge>
                </StyledTableCell>
                <StyledTableCell>{v.release_type}</StyledTableCell>
                <StyledTableCell>{v.runtime_version}</StyledTableCell>
                <StyledTableCell>
                  {v.channel === "store" ? (
                    <input
                      type="checkbox"
                      checked={v.is_mandatory}
                      disabled={savingGuid === v.guid}
                      onChange={() => handleToggleMandatory(v)}
                    />
                  ) : (
                    <span style={{ color: "var(--text-muted)" }}>—</span>
                  )}
                </StyledTableCell>
                <StyledTableCell>
                  {new Date(v.created_at).toLocaleString("pt-BR")}
                </StyledTableCell>
                <StyledTableCell>
                  <StyledButtonVisualizar
                    type="button"
                    onClick={() => setDetailsVersion(v)}
                  >
                    Visualizar
                  </StyledButtonVisualizar>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </tbody>
        </StyledTable>
      </TableContainer>

      <VersionDetailsModal version={detailsVersion} onClose={() => setDetailsVersion(null)} />
    </>
  );
}